require.register("modules/m0x/a04/page-40/page-40", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page_40 = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page_40;

  
});

